import { Box, Typography, IconButton } from "@mui/material";
import { useWindowSize } from "../../../utils/useWindowSize";

// CSS
import "./KeywordReportTitle.css";
import { useEffect, useState } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from "react-router-dom";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface propsType {
  brief: any;
  index: number;
}

const KeywordReportSummary = (props: propsType) => {
  const navigate = useNavigate();
  const windowSize = useWindowSize();
  const [textMaxWidth, setTextMaxWidth] = useState(1000);

  useEffect(() => {
    let maxWidth = windowSize.width - (windowSize.width > 1023 ? 280 : 140);
    setTextMaxWidth(maxWidth > 910 ? 910 : maxWidth);
  }, [windowSize]);

  const handleIconClick = () => {
    navigate(`/brief/${props.brief.show_pk}/${props.brief.sk}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // "&:hover": { backgroundColor: "rgba(208, 255, 0, 1)" },
      }}
    >
      <Box>
        <div className="report-summary">
          <Typography sx={{ fontSize: "1rem", fontWeight: "700", lineHeight: "24px", color: "rgba(42, 42, 42, 1)" }}>
            {String(props.index + 1).padStart(2, "0")}
          </Typography>
          <Typography
            sx={{
              // maxWidth: `${textMaxWidth}px`,
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            <div className="report-markdown" style={{ display: "inline" }}>
              <span style={{ display: "inline" }}>
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm]}
                  components={{
                    p: ({node, children}) => (
                      <span style={{ alignItems: 'center' }}>
                        {children}
                        <OpenInNewIcon 
                          sx={{ 
                            fontSize: "medium" 
                          }}
                          onClick={handleIconClick}
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                    ),
                  }}
                >
                  {props.brief.ai_data.resultContent}
                </ReactMarkdown>
              
                
              </span>
            </div>
          </Typography>
        </div>
      </Box>
    </Box>
  );
};

export default KeywordReportSummary;
